<template>
  <div class="auth-bookmarks is-max">
    <ShopProductRenderer :products="bookmarks" />
  </div>
</template>

<script setup>
const bookmarkStore = useBookmarkStore();
const bookmarks = computed(() => bookmarkStore.getBookmarks);
</script>

<style lang="scss" scoped>
.auth-bookmarks {
    @include default-content-columns;
}
</style>
